// src/components/Spinner.tsx

import React from "react";
import "./Spinner.css";

type SpinnerProps = {
  centered?: boolean;
  style?: React.CSSProperties;
  label?: string;
};

const Spinner: React.FC<SpinnerProps> = ({ centered = false, style, label }) => (
  <div className={centered ? "spinner-centered" : ""} style={style}>
    <div className="spinner" />
    {label && <div className="spinner-label">{label}</div>}
  </div>
);

export default Spinner;
